import actions from '../actions/actionTypes';
import { mapSelectedItems } from '../utils';

export const INITIAL_STATE = {
  selectedItems: [],
  filteredBy: [],
  loading: false,
};

export const notificationsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.NOTIFICATIONS_APPLY_FILTER:
      return {
        ...state,
        filteredBy: payload,
      };
    case actions.NOTIFICATIONS_SELECT:
      return {
        ...state,
        selectedItems: mapSelectedItems(payload, state.selectedItems),
      };
    case actions.NOTIFICATIONS_UNSELECT_ALL:
      return {
        ...state,
        selectedItems: [],
      };
    default:
      return state;
  }
};

export default notificationsReducer;
